import { AsyncActionHandler } from 'action-handler';

export default new AsyncActionHandler({
  name: 'fetch_wifi_connect_status',
  stateProp: 'wifi',
  handler() {
    return async () => {
      const { wifiConnectedStatus } = await window.__webview_comms__.get(
        'wifi-connected-status'
      );
      return {
        entry: wifiConnectedStatus
      };
    };
  },
  reduce(state, { entry }) {
    return {
      wifi: {
        ...state.wifi,
        ...entry
      }
    };
  }
});
